import { FunctionField, TextField, TextInput, required } from "react-admin";
import {
  MyCreate as Create,
  MyEdit as Edit,
} from "../ra-lb-tools/components/myMutator";
import { MyList } from "../ra-lb-tools/components/myList";
import { RecordSummary, MyShow } from "../ra-lb-tools/components/MyShow";
import { LabeledColumn } from "../ra-lb-tools/components/labeledColumn";
import {
  MyTabbedShowLayout,
  Tab,
} from "../ra-lb-tools/components/myTabbedShowLayout";
import get from "lodash/get";
import { YamlField } from "../ra-lb-tools/components/YamlField";
import { Debug } from "../ra-lb-tools/components/debug";
import { ConvoyLink } from "./misc/convoyLink";
import { Box } from "@mui/material";

const backToFront = (response) => ({
  ...response,
  _id: response.id,
  id: response.name,
});

export const SPWebHooksCreate = (props) => {
  return (
    <Create columns={1} ignoreEmptyFields {...props}>
      <TextInput source="sp_client_id" validate={required()} />
      <TextInput source="url" validate={required()} />
      <TextInput
        source="authentication.apiKey.headerName"
        label="Authentication Header Name"
      />
      <TextInput
        source="authentication.apiKey.headerValue"
        label="Authentication Header Value"
      />
    </Create>
  );
};

function hasNonEmptyValue(obj) {
  if (obj === null || obj === undefined) return false;

  if (typeof obj !== "object") {
    return obj !== "";
  }

  return Object.values(obj).some((value) => hasNonEmptyValue(value));
}

const WebhookAuthentication = ({ source, ...props }) => (
  <FunctionField
    source={source}
    {...props}
    render={(record) => {
      const value = get(record, source);
      if (!hasNonEmptyValue(value)) return null;

      return <YamlField source={source} />;
    }}
  />
);

export const SPWebHooksList = (props) => (
  <MyList
    {...props}
    resource="webhooks"
    queryOptions={{
      meta: {
        transformResponse: backToFront,
      },
    }}
  >
    <TextField source="_id" label="Id" sortable={false} />
    <TextField source="name" label="name/client_id" sortable={false} />
    <TextField source="url" sortable={false} />
    <TextField source="secret" sortable={false} />
    <WebhookAuthentication source="authentication" />
  </MyList>
);

const normalizeAuthenticationType = (data) => {
  if (
    !data?.authentication?.apiKey?.headerName &&
    !data?.authentication?.apiKey?.headerValue &&
    data?.authentication?.type
  ) {
    data.authentication.type = "";
  }

  return data;
};

export const SPWebHooksEdit = (props) => {
  return (
    <Edit
      queryOptions={{
        meta: {
          transformResponse: backToFront,
        },
      }}
      ignoreEmptyFields
      transform={normalizeAuthenticationType}
      {...props}
    >
      <TextInput source="id" disabled />
      <TextInput source="_id" label="Remote ID" disabled />
      <TextInput source="name" label="name/client_id" disabled />
      <TextInput source="url" />
      <TextInput
        source="authentication.apiKey.headerName"
        label="Authentication Header Name"
      />
      <TextInput
        source="authentication.apiKey.headerValue"
        label="Authentication Header Value"
      />
    </Edit>
  );
};

export const SPWebHooksShow = () => {
  return (
    <MyShow
      queryOptions={{
        meta: {
          transformResponse: backToFront,
        },
      }}
    >
      <MyTabbedShowLayout>
        <Tab label="Summary" can={true}>
          <RecordSummary>
            <LabeledColumn>
              <Box source="_id" label="Remote ID">
                <TextField source="_id" label="Remote ID" />
                <Debug>
                  <ConvoyLink source="_id" />
                </Debug>
              </Box>

              <TextField source="name" label="name/client_id" />
              <TextField source="url" />
              <TextField source="secret" sortable={false} />
            </LabeledColumn>
            <LabeledColumn>
              <WebhookAuthentication source="authentication" />
            </LabeledColumn>
          </RecordSummary>
        </Tab>
      </MyTabbedShowLayout>
    </MyShow>
  );
};
